import React from 'react';
import { Button } from '@/components/ui/button';
import { RenewalForecastGrouping } from '@/types';

interface GroupByToggleProps {
  value: RenewalForecastGrouping;
  onChange: (value: RenewalForecastGrouping) => void;
}

const OPTIONS: { value: RenewalForecastGrouping; label: string }[] = [
  { value: RenewalForecastGrouping.Month, label: 'Month' },
  { value: RenewalForecastGrouping.Quarter, label: 'Quarter' },
];

/**
 * Month / Quarter toggle for the renewal forecast. A button group with aria-pressed, so the
 * active grouping is exposed to assistive technology and to the e2e tests.
 */
export const GroupByToggle: React.FC<GroupByToggleProps> = ({ value, onChange }) => (
  <div role="group" aria-label="Group by" className="inline-flex rounded-md border border-input-border overflow-hidden">
    {OPTIONS.map((option) => (
      <Button
        key={option.value}
        type="button"
        size="sm"
        variant={option.value === value ? 'default' : 'ghost'}
        aria-pressed={option.value === value}
        className="rounded-none shadow-none"
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </Button>
    ))}
  </div>
);
